import { render, staticRenderFns } from "./audit-monitoring-service.vue?vue&type=template&id=218c916a&scoped=true"
import script from "./audit-monitoring-service.vue?vue&type=script&lang=js"
export * from "./audit-monitoring-service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218c916a",
  null
  
)

export default component.exports